import { dateObjToStr2 } from '@/utils/common'
import { getYiBaoArea } from '@/api/goodStand'
import _ from 'underscore'
export default {
  data() {
    return {
      errInfo: [],
      dataStandOpts: {
        dj: [ // 机构等级
          { value: '', text: '请选择', disabled: true },
          { value: '三级甲等' },
          { value: '三级乙等' },
          { value: '三级丙等' },
          { value: '二级甲等' },
          { value: '二级乙等' },
          { value: '二级丙等' },
          { value: '一级甲等' },
          { value: '一级乙等' },
          { value: '一级丙等' },
          { value: '未定级未定等' },
          { value: '三级' },
          { value: '三级未定等' },
          { value: '二级' },
          { value: '二级未定等' },
          { value: '一级' },
          { value: '一级未定等' },
          { value: '未定级甲等' },
          { value: '未定级乙等' },
          { value: '未定级丙等' },
          { value: '未定级' },
          { value: '未定等' }
        ],
        reg_type_1: [
          { value: '', text: '请选择', disabled: true },
          { value: '7', text: '公立' },
          { value: '8', text: '非公立' }
        ],
        reg_type_2: [
          { value: '', text: '请选择', disabled: true },
          { value: '17', text: '国有' },
          { value: '18', text: '集体' },
          { value: '19', text: '联营' },
          { value: '20', text: '私营' }
        ],
        org_type_4: [
          { value: '', text: '请选择', disabled: true },
          { value: '29', text: '综合医院' },
          { value: '30', text: '中医医院' },
          { value: '31', text: '专科医院' },
          { value: '32', text: '中西医结合医院' },
          { value: '33', text: '民族医院' },
          { value: '34', text: '护理院' },
          { value: '35', text: '社区卫生服务中心' },
          { value: '36', text: '社区卫生服务站' },
          { value: '37', text: '街道卫生院' },
          { value: '38', text: '乡镇卫生院' },
          { value: '39', text: '村卫生室' },
          { value: '40', text: '门诊部(所)' },
          { value: '41', text: '诊所(医务室、护理站)' },
          { value: '42', text: '疾病预防防护中心' },
          { value: '43', text: '专科疾病防治院(所/站)' },
          { value: '44', text: '健康教育所(站)' },
          { value: '45', text: '妇幼保健院(所/站)' },
          { value: '46', text: '急救中心(站)' },
          { value: '47', text: '卫生监督所(中心)' },
          { value: '48', text: '计划生育技术服务机构' },
          { value: '49', text: '疗养院' },
          { value: '50', text: '医学科研机构' },
          { value: '51', text: '医学在职培训机构' },
          { value: '52', text: '统计信息中心' },
          { value: '53', text: '其他' }
        ],
        one_directory: [ // 药品类别一
          { value: '', text: '请选择', disabled: true },
          { value: '中成药' },
          { value: '化学药品和生物制品' }
        ],
        two_directory: [
          { value: '', text: '请选择', disabled: true }
        ],
        two_directory_options: [[ // 药品类别二与药品类别一联动
          { value: '', text: '请选择', disabled: true },
          { value: '儿科用药' },
          { value: '内科用药' },
          { value: '外科用药' },
          { value: '妇科用药' },
          { value: '眼科用药' },
          { value: '耳鼻喉科用药' },
          { value: '骨伤科用药' }
        ], [
          { value: '', text: '请选择', disabled: true },
          { value: '儿科用药' },
          { value: '免疫呼吸系统用药' },
          { value: '呼吸系统用药' },
          { value: '耳鼻喉科用药' },
          { value: '妇产科用药' },
          { value: '心血管系统用药' },
          { value: '抗变态反应药' },
          { value: '抗寄生虫病药' },
          { value: '抗寄生虫病药；镇痛、解热、抗炎、抗风湿、抗痛风药' },
          { value: '抗微生物药' },
          { value: '抗微生物药；抗寄生虫病药；妇产科用药' },
          { value: '抗微生物药；皮肤科用药；眼科用药' },
          { value: '抗微生物药；眼科用药' },
          { value: '抗肿瘤药' },
          { value: '抗肿瘤药；皮肤科用药' },
          { value: '治疗精神障碍药' },
          { value: '泌尿系统用药' },
          { value: '消化系统用药' },
          { value: '消化系统用药；眼科用药' },
          { value: '激素及影响内分泌药' },
          { value: '激素及影响内分泌药；皮肤科用药' },
          { value: '生物制品' },
          { value: '皮肤科用药' }
        ]],
        is_execute: [
          { label: '是', text: '执行中' },
          { label: '否', text: '已废止' }
        ],
        is_yibao: [
          { label: '是', text: '是' },
          { label: '否', text: '否' }
        ],
        is_junqu: [
          { value: '是' },
          { value: '否' }
        ],
        area: [],
        type: [
          { value: '', text: '请选择', disabled: true },
          { value: '甲类' },
          { value: '乙类' },
          { value: '丙类' }
        ],
        prod_class: [
          { value: '', text: '请选择', disabled: true },
          { value: '中药' },
          { value: '化学药品' },
          { value: '生物制品' },
          { value: '辅料' }
        ],
        prd_type: [
          { value: '', text: '请选择', disabled: true },
          { value: '中药' },
          { value: '化学药品' },
          { value: '生物制品' },
          { value: '辅料' }
        ],
        doctor_level: [
          { value: '', text: '请选择', disabled: true },
          { value: '三级心理咨询师' },
          { value: '三级心理治疗师' },
          { value: '三级营养师' },
          { value: '专病门诊' },
          { value: '主任中医师' },
          { value: '主任医师' },
          { value: '主任技师' },
          { value: '主任护师' },
          { value: '主任检验师' },
          { value: '主任药师' },
          { value: '主治' },
          { value: '主治中医师' },
          { value: '主治医师' },
          { value: '主管技师' },
          { value: '主管护师' },
          { value: '主管检验师' },
          { value: '主管药师' },
          { value: '二级心理咨询师' },
          { value: '二级心理治疗师' },
          { value: '二级营养师' },
          { value: '住院医师' },
          { value: '便捷门诊' },
          { value: '副主任中医师' },
          { value: '副主任医师' },
          { value: '副主任技师' },
          { value: '副主任护师' },
          { value: '副主任检验师' },
          { value: '副主任药师' },
          { value: '助产士' },
          { value: '助理医师' },
          { value: '医师' },
          { value: '国家专家' },
          { value: '师' },
          { value: '技师' },
          { value: '护士' },
          { value: '护师' },
          { value: '普通门诊' },
          { value: '检验师' },
          { value: '治疗师' },
          { value: '省级专家' },
          { value: '药师' },
          { value: '门诊' }
        ],
        busi_mode: [
          { value: '', text: '请选择', disabled: true },
          { value: '个体工商户' },
          { value: '其他' },
          { value: '分支机构' },
          { value: '单体' },
          { value: '单体门店' },
          { value: '单体零售' },
          { value: '单体零售企业' },
          { value: '或其他单体零售企业' },
          { value: '批发' },
          { value: '批发（非法人）' },
          { value: '批发（法人）' },
          { value: '批发企业' },
          { value: '批发兼零售' },
          { value: '批发或分支机构' },
          { value: '有限责任' },
          { value: '法人' },
          { value: '法人批发企业' },
          { value: '生物制品（含疫苗）的批发' },
          { value: '第三方药品物流' },
          { value: '药品批发' },
          { value: '药品批发企业' },
          { value: '药品经营企业-零售连锁' },
          { value: '药品零售' },
          { value: '连锁' },
          { value: '连锁（总部）' },
          { value: '连锁公司' },
          { value: '连锁加盟' },
          { value: '连锁直营' },
          { value: '连锁门店' },
          { value: '零售' },
          { value: '零售（连锁）' },
          { value: '零售单体' },
          { value: '零售法' },
          { value: '零售连锁' },
          { value: '零售连锁（经营处方药和非处方药）' },
          { value: '零售连锁企业' },
          { value: '零售连锁分店' },
          { value: '零售连锁总部' },
          { value: '零售连锁门店' },
          { value: '零售（二级）' },
          { value: '零售（单体）' },
          { value: '零售（连锁）' },
          { value: '非法人' },
          { value: '非法人批发企业' }
        ]
      },
      errInfoList: {
        companyData: [[
          { label: '企业名称', field: 'name', value: '', type: 'input' },
          { label: '分类码', field: 'cat_code', value: '', type: 'input' },
          { label: '企业负责人', field: 'busi_man', value: '', type: 'input' },
          { label: '省', field: 'p_name', value: '', type: 'input' },
          { label: '市', field: 'city_name', value: '', type: 'input' },
          { label: '区、县', field: 'ad_name', value: '', type: 'input' },
          { label: '生产地址', field: 'prod_addr', value: '', type: 'textarea' },
          { label: '质量负责人', field: 'qa_person', value: '', type: 'input' },
          { label: '公司传真', field: 'fax', value: '', type: 'input' },
          { label: '发证机关', field: 'issued', value: '', type: 'input' },
          { label: '日常监督机构', field: 'regulator', value: '', type: 'input' },
          { label: '监督举报电话', field: 'supervisor_tel', value: '', type: 'input' }
        ], [
          { label: '药品生产许可证编号', field: 'license_num', value: '', type: 'input' },
          { label: '法定代表人', field: 'busi_legal', value: '', type: 'input' },
          { label: '生产范围', field: 'busi_range', value: '', type: 'input' },
          { label: '注册地址', field: 'reg_addr', value: '', type: 'textarea' },
          { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
          { label: '公司电话', field: 'tel', value: '', type: 'input' },
          { label: '公司网址', field: 'website', value: '', type: 'input' },
          { label: '签发人', field: 'sign_person', value: '', type: 'input' },
          { label: '日常监管人员', field: 'supervisors', value: '', type: 'input' }
        ]],
        shangyeData: [[
          { label: '许可证编号', field: 'license_num', value: '', type: 'input' },
          { label: '注册地址', field: 'reg_addr', value: '', type: 'textarea' },
          { label: '法人代表', field: 'busi_legal', value: '', type: 'input' },
          { label: '质量负责人', field: 'qa_person', value: '', type: 'input' },
          { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
          { label: '许可证状态', field: 'operate_status', value: '', type: 'input' }
        ], [
          { label: '企业名称', field: 'name', value: '', type: 'input' },
          { label: '仓库地址', field: 'store_address', value: '', type: 'textarea' },
          { label: '企业负责人', field: 'busi_man', value: '', type: 'input' },
          { label: '经营方式', field: 'busi_mode', value: '', type: 'select' },
          { label: '发证机构', field: 'issued', value: '', type: 'input' },
          { label: '相关数据查询', field: 'about_db', value: '', type: 'input' }
        ]],
        yiliaoData: [[
          { label: '机构名称', field: 'name', value: '', type: 'input' },
          { label: '机构等级', field: 'dj', value: '', type: 'select' },
          { label: '是否军区', field: 'is_junqu', value: '', type: 'select' },
          { label: '经营方式', field: 'reg_type_2', value: '', type: 'select' },
          { label: '门诊量(日)', field: 'outpatient', value: '', type: 'input' },
          { label: '诊疗项目', field: 'diag_item', value: '', type: 'input' },
          { label: '医院科室', field: 'departments', value: '', type: 'textarea' },
          { label: '员工数', field: 'doctors', value: '', type: 'input' },
          { label: '电话', field: 'tel', value: '', type: 'input' },
          { label: '机构地址', field: 'address', value: '', type: 'textarea' },
          { label: '网址', field: 'website', value: '', type: 'input' }
        ], [
          { label: '机构别名', field: 'alias_name', value: '', type: 'input' },
          { label: '机构类型', field: 'org_type_4', value: '', type: 'select' },
          { label: '负责人', field: 'busi_man', value: '', type: 'input' },
          { label: '床位数', field: 'bed_count', value: '', type: 'input' },
          { label: '省', field: 'p_name', value: '', type: 'input' },
          { label: '市', field: 'city_name', value: '', type: 'input' },
          { label: '区、县', field: 'ad_name', value: '', type: 'input' },
          { label: '医院设备', field: 'hos_device', value: '', type: 'input' },
          { label: '邮箱', field: 'email', value: '', type: 'input' },
          { label: '邮编', field: 'post', value: '', type: 'input' },
          { label: '机构简介', field: 'hos_syno', value: '', type: 'textarea' }
        ]],
        yaodianData: [[
          { label: '许可证编号', field: 'license_num', value: '', type: 'input' },
          { label: '注册地址', field: 'reg_addr', value: '', type: 'textarea' },
          { label: '法人代表', field: 'busi_legal', value: '', type: 'input' },
          { label: '质量负责人', field: 'qa_person', value: '', type: 'input' },
          { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
          { label: '许可证状态', field: 'operate_status', value: '', type: 'textarea' }
        ], [
          { label: '企业名称', field: 'name', value: '', type: 'input' },
          { label: '仓库地址', field: 'store_address', value: '', type: 'textarea' },
          { label: '企业负责人', field: 'busi_man', value: '', type: 'input' },
          { label: '经营方式', field: 'busi_mode', value: '', type: 'input' },
          { label: '发证机构', field: 'issued', value: '', type: 'input' },
          { label: '相关数据查询', field: 'about_db', value: '', type: 'input' }
        ]],
        yiyuanData: [[
          { label: '医院名称', field: 'name', value: '', type: 'input' },
          { label: '医院地址', field: 'address', value: '', type: 'textarea' },
          { label: '医院性质', field: 'reg_type_1', value: '', type: 'select' },
          { label: '是否军区', field: 'is_junqu', value: '', type: 'select' },
          { label: '医院设备', field: 'hos_device', value: '', type: 'input' },
          { label: '医生数量', field: 'doctors', value: '', type: 'input' },
          { label: '是否医保', field: 'is_yibao', value: '', type: 'radio' },
          { label: '医院网址', field: 'website', value: '', type: 'input' },
          { label: '诊疗项目', field: 'diag_item', value: '', type: 'input' }
        ], [
          { label: '医院简介', field: 'hos_syno', value: '', type: 'textarea' },
          { label: '医院等级', field: 'dj', value: '', type: 'select' },
          { label: '医院类型', field: 'org_type_4', value: '', type: 'select' },
          { label: '门诊量（日）', field: 'outpatient', value: '', type: 'input' },
          { label: '科室数量', field: 'ks_count', value: '', type: 'input' },
          { label: '床位数', field: 'bed_count', value: '', type: 'input' },
          { label: '联系电话', field: 'tel', value: '', type: 'input' },
          { label: '负责人', field: 'busi_man', value: '', type: 'input' },
          { label: '邮编', field: 'post', value: '', type: 'input' }
        ]],
        doctorData: [[
          { label: '医生名称', field: 'doctor_name', value: '', type: 'input' },
          { label: '科室一级', field: 'parent_name', value: '', type: 'input' },
          { label: '医生等级', field: 'doctor_level', value: '', type: 'select' }
        ], [
          { label: '医院名称', field: 'hos_name', value: '', type: 'input' },
          { label: '科室二级', field: 'depart_name', value: '', type: 'input' },
          { label: '专长', field: 'doctor_good', value: '', type: 'textarea' }
        ]],
        jiyaoData: [[
          { label: '药品名称', field: 'breed_name', value: '', type: 'input' },
          { label: '剂型规格', field: 'drug_form', value: '', type: 'input' },
          { label: '药品类别二', field: 'two_directory', value: '', type: 'select' },
          { label: '备注', field: 'context', value: '', type: 'textarea' }
        ], [
          { label: '药品名称（英文）', field: 'english_name', value: '', type: 'input' },
          { label: '药品类别一', field: 'one_directory', value: '', type: 'select' },
          { label: '文件出处', field: 'wen_jian_chu_chu', value: '', type: 'input' }
        ]],
        guochanData: [[
          { label: '批准文号', field: 'appr_num', value: '', type: 'input' },
          { label: '药品名称（英文）', field: 'en_name', value: '', type: 'input' },
          { label: '剂型', field: 'dosage_form', value: '', type: 'input' },
          { label: '上市许可持有人', field: 'listed_holder', value: '', type: 'input' },
          { label: '生产地址', field: 'ent_addr', value: '', type: 'textarea' },
          { label: '原批准文号', field: 'appr_num_o', value: '', type: 'input' }
        ], [
          { label: '药品名称', field: 'prod_name', value: '', type: 'input' },
          { label: '商品名', field: 'comm_name', value: '', type: 'input' },
          { label: '规格', field: 'specification', value: '', type: 'input' },
          { label: '生产厂家', field: 'ent_name', value: '', type: 'input' },
          { label: '药品类别', field: 'prod_class', value: '', type: 'select' },
          { label: '批准日期', field: 'appr_time', value: '', type: 'date' },
          { label: '药品本位码', field: 'std_code', value: '', type: 'input' }
        ]],
        jinkouData: [[
          { label: '药品名称（中文）', field: 'prd_name', value: '', type: 'input' },
          { label: '药品名称（英文）', field: 'en_prd_name', value: '', type: 'input' },
          { label: '注册证号', field: 'reg_num', value: '', type: 'input' },
          { label: '原注册证号', field: 'old_reg_num', value: '', type: 'input' },
          { label: '分包装批准文号', field: 'appr_num', value: '', type: 'input' },
          { label: '公司名称（中文）', field: 'com_name', value: '', type: 'input' },
          { label: '公司名称（英文）', field: 'en_com_name', value: '', type: 'input' },
          { label: '国家/地区（中文）', field: 'region', value: '', type: 'input' },
          { label: '国家/地区（英文）', field: 'en_region', value: '', type: 'input' },
          { label: '剂型', field: 'dosage_form', value: '', type: 'input' },
          { label: '规格', field: 'specification', value: '', type: 'input' },
          { label: '生产厂家（中文）', field: 'ent_name', value: '', type: 'input' },
          { label: '生产厂家（英文) ', field: 'en_ent_name', value: '', type: 'input' },
          { label: '厂家地址（英文) ', field: 'en_ent_addr', value: '', type: 'textarea' },
          { label: '发证日期', field: 'lic_time', value: '', type: 'date' },
          { label: '分包装企业名称', field: 'pac_ent_name', value: '', type: 'input' },
          { label: '分包装文号批准日期', field: 'pac_appr_time', value: '', type: 'date' },
          { label: '药品类别', field: 'prd_type', value: '', type: 'select' },
          { label: '药品本位码', field: 'std_code', value: '', type: 'input' }
        ], [
          { label: '商品名（中文）', field: 'comm_name', value: '', type: 'input' },
          { label: '商品名（英文）', field: 'en_comm_name', value: '', type: 'input' },
          { label: '注册证号备注', field: 'reg_mark', value: '', type: 'textarea' },
          { label: '地址（中文）', field: 'address', value: '', type: 'textarea' },
          { label: '地址（英文）', field: 'en_address', value: '', type: 'textarea' },
          { label: '包装规格（中文)', field: 'pac_specification', value: '', type: 'input' },
          { label: '厂家地址（中文）', field: 'ent_addr', value: '', type: 'textarea' },
          { label: '厂家国家/地区（中文）', field: 'ent_region', value: '', type: 'input' },
          { label: '厂家国家/地区（英文）', field: 'en_ent_region', value: '', type: 'input' },
          { label: '有效期截止日', field: 'expire_time', value: '', type: 'date' },
          { label: '分包装企业地址', field: 'pac_ent_addr', value: '', type: 'textarea' },
          { label: '分包装文号有效期截止日', field: 'pac_appr_expire', value: '', type: 'date' }
        ]],
        yibaoData: [[
          { label: '药品名称', field: 'yibao_drug', value: '', type: 'input' },
          { label: '别名', field: 'alias_name', value: '', type: 'input' },
          { label: '医保地区', field: 'area', value: '', type: 'select' },
          { label: '收录途径', field: 'shoulutujing', value: '', type: 'input' },
          { label: '药品分类', field: 'drug_type', value: '', type: 'input' },
          { label: '药品类别（医保）', field: 'yaopinleibie', value: '', type: 'input' },
          { label: '发文时间', field: 'time_execute', value: '', type: 'date' },
          { label: '备注', field: 'memo', value: '', type: 'textarea' }
        ], [
          { label: '剂型', field: 'drug_form', value: '', type: 'input' },
          { label: '药品集合（魔方）', field: 'yaopinjihe_mofang', value: '', type: 'textarea' },
          { label: '医保类型', field: 'type', value: '', type: 'select' },
          { label: '是否执行', field: 'is_execute', value: '', type: 'radio' },
          { label: '药品分类汇总', field: 'fenleihuizong', value: '', type: 'input' },
          { label: '更改出处', field: 'genggaichuchu', value: '', type: 'input' },
          { label: '链接', field: 'link', value: '', type: 'input' }
        ]]
      }
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.errInfo = this.errInfoList[route.params.type]
      },
      immediate: true
    },
    libForm() {
      this.showForm()
    }
  },
  mounted() {
    if (this.$route.params.type === 'yiyuanData') {
      this.dataStandOpts.org_type_4 = this.dataStandOpts.org_type_4.slice(0, 7)
    }
  },
  methods: {
    // 展示表格详情
    showForm() {
      if (this.libForm.hasOwnProperty('alias_name')) {
        this.libForm.alias_name = this.replaceAll(this.libForm.alias_name, ',/,', ',')
      }
      this.errInfo.forEach(itemArray => {
        itemArray.forEach(item => {
          if (item.type === 'daterange') {
            item.child.forEach(subItem => {
              subItem.value = this.libForm[subItem.field]
            })
          } else {
            item.value = this.libForm[item.field]
          }
        })
      })
      if (this.$route.params.type === 'jiyaoData') {
        this.showDefaultOptions(this.libForm.one_directory, false)
      }
      if (this.$route.params.type === 'yibaoData') {
        getYiBaoArea().then(res => {
          if (res.code === 0) {
            this.dataStandOpts.area = res.result.map(item => {
              return { value: item }
            })
          }
        })
      }
    },
    // 显示联级选择的二级选项
    showDefaultOptions(info, flag) {
      if (flag) {
        this.libForm.two_directory = ''
        this.errInfo[0][2].value = ''
      }
      if (info === '中成药') { // 中国基药药品分类
        this.dataStandOpts.two_directory = this.dataStandOpts.two_directory_options[0]
      } else if (info === '化学药品和生物制品') {
        this.dataStandOpts.two_directory = this.dataStandOpts.two_directory_options[1]
      } else {
        this.dataStandOpts.two_directory = [{ value: '', text: '请选择', disabled: true }]
      }
    },
    // 提交纠错信息
    submit: _.debounce(function() {
      this.$refs.libForm.validate((valid) => {
        if (!valid) {
          return false
        } else {
          let fixedParams = {}
          this.errInfo[0].concat(this.errInfo[1]).map(item => {
            if (item.type === 'daterange') {
              fixedParams[item.child[0].field] = dateObjToStr2(item.child[0].value)
              fixedParams[item.child[1].field] = dateObjToStr2(item.child[1].value)
            } else if (item.type === 'date') {
              fixedParams[item.field] = dateObjToStr2(item.value)
            } else if (item.type === 'input') {
              fixedParams[item.field] = this.libForm[item.field]
            } else {
              fixedParams[item.field] = item.value
            }
          })
          if (this.$route.params.type === 'yibaoData') { // 医保id特殊处理
            fixedParams = this.addQuery(fixedParams, 'yibao_id', this.$route.params.id)
          } else {
            fixedParams = this.addQuery(fixedParams, 'id', this.$route.params.id)
          }
          this.$emit('submit', fixedParams)
        }
      })
    }, 300, false),
    // 封装传参
    addQuery(query, name, value) {
      if (value !== undefined && value !== '') {
        query[name] = value
      }
      return query
    },
    // 替换全部
    replaceAll(str, s1, s2) {
      return str.replace(new RegExp(s1, 'gm'), s2)
    }
  }
}
